export default {
  pt: {
    pageTitle: "Renovação",
    mainTitle: "Essa é a bicicleta do seu seguro?",
    description: "Confirme se essa é a bike do seu seguro anterior para seguirmos com a renovação.",
    confirmButton: "Sim, é essa bike",
    wrongBikeButton: "Não é essa bike",
    loadErrorMessage: "Não conseguimos carregar os dados da sua bike. Fale com o suporte pra continuar.",
    supportWhatsAppText:
      "Olá! Estou renovando meu seguro e a bike exibida não é a correta. Pode me ajudar?",
  },

  en: {
    pageTitle: "Renewal",
    mainTitle: "Is this the bicycle from your insurance?",
    description: "Confirm if this is the bike from your previous insurance so we can proceed with the renewal.",
    confirmButton: "Yes, this is my bike",
    wrongBikeButton: "This is not my bike",
    loadErrorMessage: "We couldn't load your bike's details. Contact support to continue.",
    supportWhatsAppText:
      "Hello! I'm renewing my insurance and the bike shown is not correct. Can you help me?",
  },
};
